import cn from 'clsx';
import s from './title-and-variant.module.css';

const TitleAndVariant = ({ title, variantName }) => {
    return (
        <div className={s.titleWrapper}>
            <h2 className={cn(s.productTitle, 'mmds-component-one')}>
                {title}
            </h2>
            <span className={cn(s.variantName, 'mmds-component-one-detail')}>
                {variantName}
            </span>
        </div>
    );
};

export default TitleAndVariant;
